module.exports = __webpack_public_path__ + "img/IAA-image-1.d6903556.png";